import type { RequestFn } from '../http';

export interface UserNotification {
  id: string;
  type: string;
  title: string;
  body: string;
  url: string | null;
  relatedType: string | null;
  relatedId: string | null;
  readAt: string | null;
  createdAt: string;
}

export function createNotificationsApi(request: RequestFn) {
  return {
    /** Eigene Benachrichtigungen (Glocke). */
    async getNotifications(params?: { unreadOnly?: boolean; limit?: number }) {
      const q = new URLSearchParams();
      if (params?.unreadOnly) q.set('unreadOnly', 'true');
      if (params?.limit) q.set('limit', String(params.limit));
      const qs = q.toString();
      return request<{ notifications: UserNotification[] }>(`/notifications${qs ? `?${qs}` : ''}`);
    },

    /** Anzahl ungelesener Benachrichtigungen (Badge). */
    async getUnreadNotificationCount() {
      return request<{ count: number }>('/notifications/unread-count');
    },

    /** Einzelne Benachrichtigung als gelesen markieren. */
    async markNotificationRead(id: string) {
      return request<{ ok: boolean; updated: number }>(`/notifications/${id}/read`, {
        method: 'POST',
      });
    },

    /** Alle eigenen Benachrichtigungen als gelesen markieren. */
    async markAllNotificationsRead() {
      return request<{ ok: boolean; updated: number }>('/notifications/read-all', {
        method: 'POST',
      });
    },
  };
}
